import { useEffect, useState } from "react";

// * Hooks
import { Broadcast, useLazyGetBroadcastQuery } from "../features/api/apiSlice";
import { useSocketApi } from "./useSocketApi";

interface UseGetBroadcastStatusReturn {
  isOnline: boolean;
  isOffline: boolean;
  isStarted: boolean;
  isStoped: boolean;
};

const useGetBroadcastStatus = (broadcastId?: Broadcast["id"]): UseGetBroadcastStatusReturn => {
  const [getBroadcast, { data: broadcast }] = useLazyGetBroadcastQuery();

  const [status, setStatus] = useState(broadcast?.status);

  useSocketApi({
    broadcastId,
    onBroadcastStatusUpdated: ({ status }) => {
      setStatus(status);
    }
  });

  useEffect(() => {
    if (!broadcastId) return;

    getBroadcast(broadcastId)
      .unwrap()
      .then(({ status }) => {
        setStatus(status);
      });
  }, [broadcastId]);

  return {
    isOnline: status === 'online',
    isOffline: status === 'offline',
    isStarted: status === 'starting',
    isStoped: status === 'stopping'
  };
};

export default useGetBroadcastStatus;